import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

function MobileTableBody({
  item,
}) {
  const formatDate = date => moment(date).format("DD-MM-YY")

  const renderTableRow = (label, value) => (
    <tr>
      <th scope="row" className="text-uppercase">
        {label}
      </th>
      <td>{value}</td>
    </tr>
  )
  return (
    <>
        {renderTableRow("Date", formatDate(item.scrutinyNotesDate))}
        {renderTableRow("EmpId", item.employeeId)}
        {renderTableRow("EmpName", item.employeeName)}
        {renderTableRow("ScrutinyType", item.scrutinyTypeName)}
        {renderTableRow("Description", item.description)}
        {renderTableRow("Admin Notes", item.adminNotes)}
        {renderTableRow("Status", item.statusName)}
      </>
  )
}

MobileTableBody.propTypes = {
  item: PropTypes.object.isRequired,
  handleOnExpand: PropTypes.func.isRequired,
  handleVerify: PropTypes.func.isRequired,
}

export default MobileTableBody
